import Fingerprint from 'fingerprintjs';

export const myFingerprint = () => {
    let myFg = localStorage._myFingerprint;
    if (!myFg) {
        myFg = new Fingerprint().get();
        localStorage._myFingerprint = myFg;
    }
    return myFg;
};
